import { CollectionType } from '@/enums/collection-type';
import {
	PopularProviderPageExpName,
	PopularProviderPageExpVariantName,
} from '@/enums/experiments/popular-provider-page-exp';
import { PopularTabType } from '@/interfaces/titles';
import { FilterCollection } from '@/stores/filter.store';
import { SnowplowExperimentContext, TrackingProviderPropertiesInterface } from '../tracking/providers';
import { SnowplowContext } from '../tracking/providers/snowplow-contexts';
import { TrackingHelper } from '../tracking/tracking-helper';
import { getVm } from '../vm-helper';

interface TrackEventArgs {
	action: 'clickout' | 'impression' | 'click';
	label?: string;
	variant?: PopularProviderPageExpVariantName;
	version?: string;
	contexts?: SnowplowContext[];
	property?: string;
}

export const experimentProviders = ['amp', 'nfx', 'dnp', 'fuv', 'hbm'] as const;
export type experimentProvidersShortName = (typeof experimentProviders)[number];

function getSelectedTab(routeName: string): PopularTabType | undefined | 'plans' {
	const name = routeName.split('app.titles.popular.provider')[1];
	if (name === undefined) {
		return undefined;
	}
	switch (name) {
		case '-movie':
			return PopularTabType.MOVIE;
		case '-show':
			return PopularTabType.SHOW;
		case '-plans':
			return 'plans';
		default:
			return PopularTabType.ALL;
	}
}

export function isExperimentActive(_routeName?: string): boolean {
	const vm = getVm();
	const filterPopular: FilterCollection = vm?.$store.getters['filter/' + CollectionType.POPULAR];

	const variant = vm?.$store.getters['experiment/activeVariantsWithControlGroup'][
		PopularProviderPageExpName
	] as PopularProviderPageExpVariantName;

	const isLoggedIn: () => boolean = vm?.$store.getters['user/isLoggedIn'];

	const routeName: string = _routeName || vm?._route?.name;

	return (
		filterPopular.providers.length === 1 &&
		!isLoggedIn() &&
		!!variant &&
		routeName.startsWith('app.titles.popular.provider') &&
		experimentProviders.includes(filterPopular.providers[0] as any)
	);
}

export function providerPageExpTrackEvent(
	{ version = '1', action, label, contexts = [], property }: TrackEventArgs,
	_routeName?: string
) {
	const vm = getVm();

	if (!isExperimentActive(_routeName)) {
		return;
	}

	const variant = vm?.$store.getters['experiment/activeVariantsWithControlGroup'][
		PopularProviderPageExpName
	] as PopularProviderPageExpVariantName;

	const routeName: string = _routeName || vm?._route?.name;
	const selectedTab = getSelectedTab(routeName);

	const properties: TrackingProviderPropertiesInterface = { action, label, property: property ?? selectedTab };
	if (action === 'impression') properties.nonInteraction = true;

	const expContext = new SnowplowExperimentContext(PopularProviderPageExpName, version, variant);
	TrackingHelper.trackEvent('onpage_test', properties, [...contexts, expContext]);
}

export function loadMicrosoftClarity() {
	const scriptId = 'microsoft-clarity';
	if (document.getElementById(scriptId)) return;

	const scriptText = `
                        (function(c,l,a,r,i,t,y){
                        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                        })(window, document, "clarity", "script", "ffbppisl6e");
                    `;

	const script = document.createElement('script');
	script.innerHTML = scriptText;
	script.id = scriptId;
	document.head.appendChild(script);
}
